/* eslint-disable react/prop-types */
/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable import/prefer-default-export */
import React, { useCallback, useEffect, useState } from 'react'
import fetchFilterData from 'api/search'
import s from './BedBaths.module.css'

import { Bed } from 'components/listings/search/SearchBar/SearchBarButtons'

export function BedBaths({ selectedData }) {
  const [filterData, setFilterData] = useState({
    baths: [],
    bedrooms: [],
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchFilterData().then((results) => {
      setFilterData(results)
      setLoading(false)
    })
  }, [])

  const handleChange = useCallback((data) => {
    const listingBeds = document.querySelector('#listing_search_form_bed_list')
    const leaseBeds = document.querySelector('#lease_search_form_bed_list')
    const listingBaths = document.querySelector('#listing_search_form_min_baths')

    if (listingBeds) {
      listingBeds.setAttribute('value', data.bedrooms.join())
    }
    if (leaseBeds) {
      leaseBeds.setAttribute('value', data.bedrooms.join())
    }
    if (listingBaths) {
      listingBaths.setAttribute('value', data.baths.join())
    }
  })

  return (
    <Bed
      customClassName={s.root}
      key="matrix-bed-bath"
      selected={{
        bedrooms: selectedData && selectedData.bed_list.length > 0 ? selectedData.bed_list : [],
        baths: selectedData && selectedData.min_baths ? [String(selectedData.min_baths)] : [],
      }}
      isBathRadio
      onChange={handleChange}
      loading={loading}
      options={{
        bedrooms: filterData.bedrooms,
        baths: filterData.baths,
      }}
    />
  )
}
